import { render, staticRenderFns } from "./NovoAdminAviso.vue?vue&type=template&id=2684f1f8&scoped=true&"
import script from "./NovoAdminAviso.vue?vue&type=script&lang=js&"
export * from "./NovoAdminAviso.vue?vue&type=script&lang=js&"
import style0 from "./NovoAdminAviso.vue?vue&type=style&index=0&id=2684f1f8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2684f1f8",
  null
  
)

export default component.exports